function HtmlExportService() {
  const ExportContainerId = 'blocksContainer';

  const exportHTML = `<!DOCTYPE html>
  <html lang="ja" style="height:100%">
      ${document.head.outerHTML}
      <body data-theme="jasv" style="height:100% !important;">
      <div id="root" style="height:100% !important; width:100% !important">
      ${document.getElementById(ExportContainerId).outerHTML}
      </div>
    </body>
  </html>
  `;

  const file = new Blob([exportHTML], { type: 'text/plain' });
  return file;
}

export default HtmlExportService;
